import api from './api';

export interface HomepageSection {
  section: string;
  language: string;
  content: any;
  isActive: boolean;
}

const homepageService = {
  // Get all sections for a language
  getContent: async (lang: string = 'vi'): Promise<Record<string, any>> => {
    const data = await api.get<any, Record<string, any>>(`/homepage?lang=${lang}`);
    return data;
  },

  // Update a specific section
  updateSection: async (section: string, language: string, content: any): Promise<HomepageSection> => {
    const data = await api.put<any, HomepageSection>(`/homepage/${section}`, {
      language,
      content,
    });
    return data;
  },

  // Upload an image to Cloudinary via Admin generic endpoint
  uploadImage: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append("file", file);
    
    // Using api directly, it handles the response data unwrapping
    const response = await api.post<any, { url: string }>("/admin/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      // Upload can take minutes on a slow connection; override the global 60s
      // default so the request body has time to finish sending.
      timeout: 600000,
    });
    
    return response.url;
  },
};

export default homepageService;
